"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadialProgress = void 0;

var React = _interopRequireWildcard(require("react"));

var _renderers = require("./renderers/");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RadialProgress =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadialProgress, _React$Component);

  function RadialProgress() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RadialProgress);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadialProgress)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      startTime: Date.now(),
      duration: null,
      proportion: null
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "raf", void 0);

    _defineProperty(_assertThisInitialized(_this), "graphic", void 0);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.isMounted = true;
      _this.raf = window.requestAnimationFrame.bind(window);

      _this.startAnimating();
    });

    _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
      return Math.abs(_this.props.startStep - _this.props.step) / _this.props.steps * _this.props.duration;
    });

    _defineProperty(_assertThisInitialized(_this), "getProportion", function () {
      var duration = _this.getDuration();

      if (duration == 0) {
        return 1;
      }

      return Math.min(Date.now() - _this.state.startTime, duration) / duration;
    });

    _defineProperty(_assertThisInitialized(_this), "animate", function () {
      if (!_this.isMounted) {
        return;
      }

      var proportion = _this.getProportion();

      _this.setState({
        proportion: proportion
      }); // Animate until end


      if (proportion < 1) {
        _this.raf(function () {
          _this.animate();
        });
      } else {// Done
      }
    });

    return _this;
  }

  _createClass(RadialProgress, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isMounted = false;
      this.cancelAnimating();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.startStep !== this.props.startStep || nextProps.step !== this.props.step) {
        this.startAnimating();
      }

      return true;
    }
  }, {
    key: "startAnimating",
    value: function startAnimating() {
      var _this2 = this;

      this.setState({
        proportion: null,
        startTime: Date.now()
      });
      this.raf(function () {
        _this2.animate();
      });
    }
  }, {
    key: "cancelAnimating",
    value: function cancelAnimating() {
      window.cancelAnimationFrame(this.raf);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var debug = function debug(proportion) {
        return React.createElement("ul", {
          style: {
            fontFamily: 'monospace'
          }
        }, React.createElement("li", null, "startProportion: ", startProportion), React.createElement("li", null, "endProportion: ", endProportion), React.createElement("li", null, "getProportion(): ", _this3.getProportion()), React.createElement("li", null, "proportion: ", proportion), React.createElement("li", null, "props.duration: ", _this3.props.duration), React.createElement("li", null, "getDuration(): ", _this3.getDuration()));
      };

      var label = function label(steps, proportion) {
        if (_this3.graphic && _this3.graphic.canvas) {
          var rect = _this3.graphic.canvas.getBoundingClientRect();

          var diameter = Math.min(rect.height, rect.width);
          var style = {
            position: 'absolute',
            textAlign: 'center',
            color: _this3.props.ringFgColour,
            fontSize: "".concat(diameter / _this3.props.fontRatio, "px")
          };
          return React.createElement("div", {
            className: "RadialProgressIndicator__label",
            style: style
          }, _this3.props.text(steps, proportion));
        }

        return null;
      };

      var startProportion = this.props.startStep / this.props.steps;
      var endProportion = this.props.step / this.props.steps;
      var proportion = startProportion + (endProportion - startProportion) * this.getProportion();
      return React.createElement("div", {
        className: "RadialProgressIndicator",
        style: {
          position: 'relative',
          width: this.props.width,
          height: this.props.height,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, React.createElement(_renderers.CanvasRenderer, {
        ref: function ref(_ref) {
          return _this3.graphic = _ref;
        },
        proportion: proportion,
        showIntermediateProgress: this.props.showIntermediateProgress,
        segmented: this.props.segmented,
        steps: this.props.steps,
        ringThickness: this.props.ringThickness,
        ringBgColour: this.props.ringBgColour,
        ringFgColour: this.props.ringFgColour,
        ringIntermediateColour: this.props.ringIntermediateColour,
        backgroundColour: this.props.backgroundColour,
        backgroundTransparent: this.props.backgroundTransparent
      }), label(this.props.steps, proportion));
    }
  }, {
    key: "isMounted",
    get: function get() {
      return this._isMounted;
    },
    set: function set(value) {
      this._isMounted = value;
    }
  }]);

  return RadialProgress;
}(React.Component);

exports.RadialProgress = RadialProgress;

_defineProperty(RadialProgress, "defaultProps", {
  width: 100,
  height: 100,
  steps: 10,
  step: 10,
  startStep: 0,
  duration: 5000,
  ringThickness: 0.2,
  ringBgColour: '#ccc',
  ringFgColour: '#3c763d',
  ringIntermediateColour: '#aaa',
  backgroundColour: '#dff0d8',
  backgroundTransparent: true,
  showIntermediateProgress: false,
  segmented: true,
  fontRatio: 4,
  text: function text(steps, proportion) {
    var step = Math.floor(steps * proportion);
    return "".concat(step, "/").concat(steps);
  }
});